import * as Api from '../../../weborder/Api';
import { Async } from '../../../weborder/Data';
import * as Store from '../../../weborder/Store';
import { Campaign, SetCampaignProgress } from './store.types';

const setCollectionSummaries = (
  collectionSummaries: Async<Api.CollectionRestaurantSummary[]>,
): Store.SetCollectionSummaries => ({
  type: 'SET_COLLECTION_SUMMARIES',
  payload: collectionSummaries,
});

const setDeliverySummaries = (
  deliverySummaries: Async<Api.DeliveryRestaurantSummary[]>,
): Store.SetDeliverySummaries => ({
  type: 'SET_DELIVERY_SUMMARIES',
  payload: deliverySummaries,
});

export const setCampaignProgress = (
  campaignProgress: Async<Campaign[]> & { storeId: number },
): SetCampaignProgress => ({
  type: 'SET_CAMPAIGN_PROGRESS',
  payload: campaignProgress,
});

export const storeActions = {
  setCollectionSummaries,
  setDeliverySummaries,
};
